"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducers = exports.onlyResourceReducers = exports.collaborators = exports.unitInfo = exports.pageParams = exports.mirrorMap = void 0;
const redux_1 = require("redux");
const resource_1 = require("../../modules/database/store/reducers/resource");
const dashboard_1 = require("../../modules/database/store/reducers/resource/dashboard");
const page_params_1 = require("../../modules/database/store/reducers/page_params");
Object.defineProperty(exports, "pageParams", { enumerable: true, get: function () { return page_params_1.pageParams; } });
const catalog_tree_1 = require("../../modules/space/store/reducers/catalog_tree");
const user_1 = require("../../modules/user/store/reducers/user");
const space_1 = require("../../modules/space/store/reducers/space");
const share_1 = require("../../modules/space/store/reducers/share");
const address_list_1 = require("../../modules/org/store/reducers/address_list");
const space_member_manage_1 = require("../../modules/org/store/reducers/space_member_manage");
const invite_1 = require("../../modules/org/store/reducers/invite");
const space_permission_manage_1 = require("../../modules/org/store/reducers/space_permission_manage");
const notification_1 = require("../../modules/user/store/reducers/notification");
// @ts-ignore
const enterprise_1 = require("../../modules/enterprise");
const toolbar_1 = require("../../modules/database/store/reducers/toolbar");
const right_pane_1 = require("../../modules/database/store/reducers/right_pane");
const template_centre_1 = require("../../modules/space/store/reducers/template_centre");
const unit_info_1 = require("../../modules/org/store/reducers/unit_info");
Object.defineProperty(exports, "unitInfo", { enumerable: true, get: function () { return unit_info_1.unitInfo; } });
const mirror_1 = require("../../modules/database/store/reducers/resource/mirror");
Object.defineProperty(exports, "mirrorMap", { enumerable: true, get: function () { return mirror_1.mirrorMap; } });
const labs_1 = require("../../modules/space/store/reducers/labs");
const subscriptions_1 = require("../../modules/database/store/reducers/subscriptions");
const record_vision_mode_1 = require("../../modules/database/store/reducers/record_vision_mode");
const preview_file_1 = require("../../modules/database/store/reducers/preview_file");
const embed_1 = require("../../modules/embed/store/reducers/embed");
const collaborators_1 = require("../../modules/database/store/reducers/resource/datasheet/collaborators");
Object.defineProperty(exports, "collaborators", { enumerable: true, get: function () { return collaborators_1.collaborators; } });
exports.onlyResourceReducers = (0, redux_1.combineReducers)({
    isStateRoot: () => true,
    datasheetMap: resource_1.datasheetMap,
    widgetMap: resource_1.widgetMap,
    dashboardMap: dashboard_1.dashboardMap,
    formMap: resource_1.formMap,
    pageParams: page_params_1.pageParams,
    space: space_1.space,
    unitInfo: unit_info_1.unitInfo,
    embedInfo: embed_1.embedInfo
});
exports.rootReducers = (0, redux_1.combineReducers)({
    isStateRoot: () => true,
    recordVision: record_vision_mode_1.recordVision,
    theme: resource_1.theme,
    datasheetMap: resource_1.datasheetMap,
    mirrorMap: mirror_1.mirrorMap,
    widgetMap: resource_1.widgetMap,
    dashboardMap: dashboard_1.dashboardMap,
    formMap: resource_1.formMap,
    pageParams: page_params_1.pageParams,
    catalogTree: catalog_tree_1.catalogTree,
    user: user_1.user,
    addressList: address_list_1.addressList,
    spaceMemberManage: space_member_manage_1.spaceMemberManage,
    space: space_1.space,
    share: share_1.share,
    invite: invite_1.invite,
    spacePermissionManage: space_permission_manage_1.spacePermissionManage,
    notification: notification_1.notification,
    hooks: enterprise_1.guide,
    toolbar: toolbar_1.toolbar,
    rightPane: right_pane_1.rightPane,
    billing: enterprise_1.billing,
    templateCentre: template_centre_1.templateCentre,
    unitInfo: unit_info_1.unitInfo,
    labs: labs_1.labs,
    subscriptions: subscriptions_1.subscriptions,
    previewFile: preview_file_1.previewFile,
    embedInfo: embed_1.embedInfo
});
//# sourceMappingURL=reducers.js.map